import { createAction, handleActions } from 'redux-actions'

const setSearchTerm = createAction('SCREENS/INSIGHTS/SET_SEARCH_TERM')
const resetSearchTerm = createAction('SCREENS/INSIGHTS/RESET_SEARCH_TERM')

const defaultState = ''

const reducer = handleActions(
  {
    [setSearchTerm]: (state, action) => action.payload,
    [resetSearchTerm]: () => defaultState,
  },
  defaultState,
)

export { setSearchTerm, resetSearchTerm, reducer }
